import React from 'react'
import Navbar from './Navbar';
import styled from 'styled-components';


const SidebarStyled = styled.div`
    width: 16.3rem;
    position: fixed;
    height: 100vh;
    background-color: var(--sidebar-dark-color);
    overflow: hidden;
    transition: all .4s ease-in-out;
    @media screen and (max-width:1200px){
        transform: translateX(-100%);
        z-index: 20;
    }
`;

const Sidebar = ({ navToggle, setNavToggle }) => {
    return (
        <SidebarStyled className={`${navToggle ? 'nav-toggle' : ''}`}>
            <Navbar navToggle={navToggle} setNavToggle={setNavToggle} />
        </SidebarStyled>
    )
}

export default Sidebar